































import { Component, Prop, Vue, Watch, Emit } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";

const Root = namespace("root");

@Component({ components: {} })
export default class gtWtExport extends Vue {
  @Root.Action exportProductExcel;
  @Root.State mainRouter;
  @Prop({ default: false, type: Boolean }) value: Boolean; // v-model,弹窗是否显示
  @Prop({ default: () => {}, type: Object }) params: Object;
  @Prop({ default: () => {}, type: Function }) fn: Function;
  @Prop({ default: () => {}, type: Function }) emptyFn: Function; // 空的
  @Prop({ default: () => {}, type: Function }) closeFn: Function; // 关闭的回调
  @Prop({ default: "0", type: String }) routeParams: String; // 是跟在导出链接后面的参数

  visible: boolean = false;
  isFilter = false;
  notice: any = "";
  private loading = false;

  @Watch("visible")
  onvisibleChange(val, oldVal) {
    this.isFilter = true;
  }
  @Watch("value")
  onValChange(val) {
    this.visible = val;
  }
  onClosed(val) {
    this.$emit("input", val);
  }
  handelCancel() {
    this.visible = false;
  }
  async handleExport() {
    this.notice && this.notice.close();
    const fn = this.fn;
    try {
      // TODO: Emit loaded
      this.loading = true;
      if (this.unDefaultFn(fn)) {
        await fn(this.params);
      } else {
        await this.exportProductExcel(this.params);
      }
    } catch (error) {
      console.log(error);
      return false;
    } finally {
      this.loading = false;
    }
    this.visible = false;
    const h = this.$createElement;
    this.notice = this.$message({
      type: "success",
      duration: 0,
      showClose: true,
      customClass: "gt-export-dialog-message-wrap",
      message: h("div", { class: "gt-export-dialog-product-success" }, [
        h("p", null, this.$tc("exportPage.success_export")),
        h(
          "p",
          {
            class: "gt-export-dialog-product-view",
            on: {
              click: this.handleViewExport
            }
          },
          this.$tc("exportPage.view_export")
        )
      ])
    });
  }
  handleViewExport() {
    this.notice && this.notice.close();
    if (this.unDefaultFn(this.closeFn)) {
      this.closeFn(); // bind
      return;
    }
    let menuMap: any = JSON.parse(localStorage.getItem("menuListMap") || "{}");
    let ygjExportPath: any = "/app/k-one-frontend/export";
    let appCode = window.__GTECH_VARIABLES_APP_CODE__;

    if (menuMap[ygjExportPath]) {
      // "K-ONE", "WIN-TOGETHER-TBR"
      if (appCode === "WIN-TOGETHER-TBR" && this.mainRouter) {
        let routeUrl = this.mainRouter.resolve({
          // this.mainRouter.push({
          path: ygjExportPath,
          query: { exportParams: String(this.routeParams || "") }
        });
        window.open(routeUrl.href, "_blank");
        return;
      }
      if (["WIN-TOGETHER", "WIN-TOGETHER-CN"].includes(appCode)) {
        let routeUrl = this.$router.resolve({
          path: ygjExportPath,
          query: { exportParams: String(this.routeParams || "") }
        });
        window.open(routeUrl.href, "_blank");
        return;
      }
    }
    //

    // if (appCode === "K-ONE") {
    let routeUrl = this.$router.resolve({
      name: "Export",
      query: { exportParams: String(this.routeParams || "") }
    });
    window.open(routeUrl.href, "_blank");
    // } else {
    //   this.$router.push({
    //     name: "Export",
    //     query: { exportParams: String(this.routeParams || "") }
    //   });
    // }
  }
  unDefaultFn(fn) {
    // TODO: fix judge fn
    if (fn && typeof fn === "function") {
      return fn.toString() !== this.emptyFn.toString();
    }
    return false;
  }
  destroyed() {
    this.notice && this.notice.close();
  }
}
